import React from 'react'
import { StaticQuery, graphql } from 'gatsby'
import config from '../../../config'
import { SidebarStyle, ListItemStyle } from './RightSidebar.css'


const titleToId = title =>
  title
    .toLowerCase()
    .replace(/\s+/g, '-')
    .replace(/[åä]/g, 'a')
    .replace(/ö/g, 'o')


// eslint-disable-next-line no-unused-vars
const ListItem = ({ className, active, level, ...props }) => {
  return (
    <li css={ListItemStyle()} className={className}>
      <a href={props.to} {...props} />
    </li>
  )
}

const SidebarLayout = ({ location }) => (
  <StaticQuery
    query={graphql`
      query {
        allMdx {
          edges {
            node {
              fields {
                slug
              }
              tableOfContents
            }
          }
        }
      }
    `}
    render={({ allMdx }) => {

      const onScrollToClick = (e) => {
        e.preventDefault()
        const element = document.getElementById(e.target.href.split('#').pop())
        element.scrollIntoView({
          behavior: "smooth",
        })

        element.classList.add("scrolledTo")

        //move focus to the heading
        element.setAttribute("tabIndex",0)
        element.focus({preventScroll: true})
        element.removeAttribute("tabIndex")

        window.setTimeout(() => {
          element.classList.remove("scrolledTo");
        },800)

      }

      let finalNavItems
      if (allMdx.edges !== undefined && allMdx.edges.length > 0) {
        allMdx.edges.map((item, index) => {
          let innerItems
          if (item !== undefined) {
            if (
              item.node.fields.slug === location.pathname ||
              config.gatsby.pathPrefix + item.node.fields.slug ===
                location.pathname
            ) {
              if (item.node.tableOfContents.items) {
                innerItems = item.node.tableOfContents.items.map(
                  (innerItem, index) => {
                    const itemId = innerItem.title
                      ? titleToId(innerItem.title)
                      : '#'
                    return (
                      <ListItem key={index} to={`#${itemId}`} level={1} onClick={onScrollToClick}>
                        {innerItem.title}
                      </ListItem>
                    )
                  }
                )
              }
            }
          }
          if (innerItems) {
            finalNavItems = innerItems
          }
        })
      }

      if (finalNavItems && finalNavItems.length) {
        return (
          <aside css={SidebarStyle}>
            <ul className={'rightSideBarUL'}>
              <div className={'rightSideTitle'}>{config.siteMetadata.language == "sv" ? "Innehåll" : "Contents"}</div>
              {finalNavItems}
            </ul>
          </aside>
        )
      } else {
        return (
          <aside css={SidebarStyle}>
            <ul />
          </aside>
        )
      }
    }}
  />
)

export default SidebarLayout
